import React from "react";
import {
    alpha,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import RepeatRounded from "@mui/icons-material/RepeatRounded";
import { BlockedTimeSlot } from "../Dashboard/Calendar/BlockedSlotItem";
import Button from "../Button";
import { FONTS } from "../../constants/styles";

interface Props {
    open: boolean;
    slot: BlockedTimeSlot;
    onClose: () => void;
    onConfirm: (interval: "weekly" | "monthly") => void;
}

const MakeRecurringSlotModal: React.FC<Props> = ({
    open,
    slot,
    onClose,
    onConfirm,
}) => {
    const theme = useTheme();
    const hex = theme.palette.primary.main;

    return (
        <Dialog
            className="force-dynamic-translation"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    p: 3,
                    textAlign: "center",
                    boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.12)",
                    maxWidth: 360,
                    mx: 2,
                },
            }}
        >
            <DialogTitle sx={{ p: 0, pb: 0.5 }}>
                <Stack spacing={2} alignItems="center">
                    {/* Tinted icon box */}
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "14px",
                            bgcolor: alpha(hex, 0.1),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 auto",
                            color: hex,
                        }}
                    >
                        <RepeatRounded sx={{ fontSize: 24 }} />
                    </Box>
                    <Typography
                        fontFamily={FONTS.display}
                        fontWeight={700}
                        fontSize="20px"
                    >
                        Make this slot recurring?
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ p: 0, pt: 1 }}>
                <Typography
                    fontWeight={400}
                    fontSize="14px"
                    lineHeight="150%"
                    color="text.secondary"
                >
                    Automatically block this time every week
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{ justifyContent: "center", p: 0, pt: 2.5 }}
            >
                <Button
                    onClick={() => {
                        onConfirm("weekly");
                        onClose();
                    }}
                    variant="medium"
                    color="primary"
                >
                    Make recurring
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MakeRecurringSlotModal;
